import { z } from "zod";

export const MAX_DISTINCT_REACTIONS_PER_MESSAGE = 20;

const MAX_UNICODE_EMOJI_LENGTH = 32;

const KEYCAP = "[0-9#*]\\uFE0F?\\u20E3";
const FLAG = "\\p{Regional_Indicator}{2}";
const TAG_SEQUENCE = "[\\u{E0020}-\\u{E007E}]+\\u{E007F}";
const PICTOGRAPH = `\\p{Extended_Pictographic}(?:\\uFE0F|\\p{Emoji_Modifier}|${TAG_SEQUENCE})?`;
const EMOJI_ELEMENT = `(?:${KEYCAP}|${FLAG}|${PICTOGRAPH})`;

const UNICODE_EMOJI_PATTERN = new RegExp(
    `^${EMOJI_ELEMENT}(?:\\u200D${EMOJI_ELEMENT})*$`,
    "u",
);

export const UnicodeEmojiSchema = z
    .string()
    .max(MAX_UNICODE_EMOJI_LENGTH)
    .regex(UNICODE_EMOJI_PATTERN, "Choose a valid emoji");

const UnicodeReactionSchema = z.object({
    type: z.literal("unicode"),
    emoji: UnicodeEmojiSchema,
});

export const ChatReactionSchema = z.discriminatedUnion("type", [
    UnicodeReactionSchema,
    z.object({ type: z.literal("custom"), emojiId: z.string().uuid() }),
]);
export type ChatReaction = z.infer<typeof ChatReactionSchema>;

export const MessageReactionSchema = z.object({
    reaction: ChatReactionSchema,
    userIds: z.array(z.number().int()),
});
export type MessageReaction = z.infer<typeof MessageReactionSchema>;

export const ChatReactionBodySchema = z.object({
    reaction: UnicodeReactionSchema,
});
